import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Observable, merge, fromEvent, of as observableOf } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator } from '@angular/material';
import { Location } from '@angular/common';
import { ProviderService } from '../services/provider/provider.service';
import { debounceTime, distinctUntilChanged, catchError, map, startWith, switchMap } from 'rxjs/operators';

@Component({
    selector: 'provider',
    templateUrl: './provider.component.html'
})
export class ProviderComponent implements OnInit {
    public title: string = 'Proveedores';
    public providersColumns = ['name', 'actions'];
    public providers: any;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;
    public refreshing: boolean = true;
    public params: any = {};
    public resultsLength = 0;

    constructor(private route: ActivatedRoute, private router: Router, private location: Location, private providerService: ProviderService) { }

    ngOnInit() {
        fromEvent(this.filter.nativeElement, 'keyup')
            .pipe(debounceTime(300))
            .pipe(distinctUntilChanged())
            .subscribe(() => {
                this.searchProviders();
            });
        this.route.queryParams.subscribe(params => {
            this.paginator.pageIndex = this.params.page = (params.page) ? params.page : 0;
            this.params.s = (params.s) ? params.s : null;
            this.filter.nativeElement.value = (this.params.s) ? this.params.s : '';
        });
        this.loadProviders();
    }

    searchProviders() {
        this.refreshing = true;
        this.params.page = this.paginator.pageIndex = 0;
        this.params.s = this.filter.nativeElement.value;
        this.params = (this.params.s) ? {page: this.params.page, s: this.params.s} : {page: this.params.page};
        this.providerService.getProviders(this.params).subscribe(data => {
            this.refreshing = false;
            this.resultsLength = data.total_count;
            this.providers = data.items;
            this.router.navigate(['/app/provider'], {queryParams: this.params});
        });
    }

    loadProviders() {
        this.paginator.page.pipe(
            startWith({}),
            switchMap(() => {
                this.refreshing = true;
                this.params.page = this.paginator.pageIndex;
                this.params = (this.params.s) ? {page: this.params.page, s: this.params.s} : {page: this.params.page};
                return this.providerService!.getProviders(this.params);
            }),
            map(data => {
                this.refreshing = false;
                this.resultsLength = data.total_count;
                this.params = (this.params.s) ? {page: this.params.page, s: this.params.s} : {page: this.params.page};
                this.router.navigate(['/app/provider'], {queryParams: this.params});
                return data.items;
            }),
            catchError(() => {
                this.refreshing = false;
                console.log('data retrieve error');
                return observableOf([]);
            })
        ).subscribe(data => this.providers = data);
    }

}
